// AddDatabaseModalTemplateStep.jsx

import React from 'react';

// Components
import LibrarySection from 'components/addmodal/sections/library/LibrarySection';

/**
 * AddDatabaseModalTemplateStep
 *
 * Renders the template selection and addon provisioning step.
 *
 * @param {object} libraryState - Library provisioning state and handlers.
 *
 * @returns {ReactNode} The rendered template step.
 */
const AddDatabaseModalTemplateStep = ({ libraryState }) => {

    // ----- RENDER ----- //

    return (
        <LibrarySection
          query={libraryState.query}
          setQuery={libraryState.setQuery}
          loading={libraryState.loading}
          error={libraryState.error}
          terms={libraryState.terms}
          selectedTerm={libraryState.selectedTerm}
          selectedAddon={libraryState.selectedAddon}
          isAddonStep={libraryState.isAddonStep}
          isAddonPreviewStep={libraryState.isAddonPreviewStep}
          isProvisioning={libraryState.isProvisioning}
          provisioningAddonKey={libraryState.provisioningAddonKey}
          selectedFieldKeys={libraryState.selectedFieldKeys}
          baseKey={libraryState.baseKey}
          onSelectAddon={libraryState.handleSelectAddon}
          onSelectTerm={libraryState.handleSelectTerm}
          onToggleSelectedField={libraryState.handleToggleSelectedField}
        />
    );
};

// Dev Tools
AddDatabaseModalTemplateStep.displayName = 'AddDatabaseModalTemplateStep';

export default AddDatabaseModalTemplateStep;
